import { cva } from 'class-variance-authority';

export const iconButtonVariants = cva(
  'inline-flex rounded-control py-1.5 px-2 focus:outline-none items-center text-[13px] font-medium transition-[background-color,color,transform] duration-150 ease-out-strong active:scale-[0.94]',
  {
    variants: {
      variant: {
        ghost:
          'text-neutral-600 hover:bg-neutral-900/[0.05] hover:text-neutral-900 dark:hover:bg-white/[0.06]',
        // Aliases kept for any legacy call sites
        'ghost-dark':
          'text-neutral-600 hover:bg-neutral-900/[0.05] hover:text-neutral-900 dark:hover:bg-white/[0.06]',
        'ghost-light':
          'text-neutral-600 hover:bg-neutral-900/[0.05] hover:text-neutral-900 dark:hover:bg-white/[0.06]',
      },
    },
    defaultVariants: {
      variant: 'ghost',
    },
  }
);
